import { DefaultResponseWithData } from "./system";
import { IPlannerVehicleRow, VehicleProductionLine } from "./ProductionPlanner";
import { DismantlingBayType } from "./DismantlingBay";
import { VehicleComplexity } from "./Vehicle";

export enum ProductionManagerBayStatus {
  Available = 0,
  InProgress = 1,
  Complete = 2,
}

export interface IBaysInUseKpi {
  used: number;
  total: number;
}

export interface IPartsRemovedBreakdownEntry {
  name: string;
  count: number;
}

export interface IPartsRemovedKpi {
  total: number;
  breakdown: IPartsRemovedBreakdownEntry[];
}

export interface IProductionManagerKpis {
  baysInUse: IBaysInUseKpi;
  linesInUse: IBaysInUseKpi;
  vehiclesInProgress: number;
  vehiclesDismantledToday: number;
  partsRemoved: IPartsRemovedKpi;
}

export interface IProductionManagerBayVehicle {
  id: string;
  vrm: string;
  stockNumber: string | null;
  combinedMake: string | null;
  combinedModel: string | null;
  bodyStyle: string | null;
  complexity: VehicleComplexity;
  productionLine: VehicleProductionLine;
  partsRemoved: number;
  partsTotal: number;
  percentComplete: number;
  currentAssemblyName: string | null;
  currentAssemblyIndex: number | null;
  assemblyCount: number;
  currentAssemblyElapsedSeconds: number;
  currentAssemblyStartedOn: string | null;
  currentAssemblyAverageMinutes: number | null;
}

export interface IProductionManagerBay {
  id: string;
  name: string;
  type: DismantlingBayType;
  line: VehicleProductionLine;
  status: ProductionManagerBayStatus;
  currentVehicle: IProductionManagerBayVehicle | null;
  currentVehicles: IProductionManagerBayVehicle[];
  dueNext: IPlannerVehicleRow[];
}

export interface IProductionManagerOverview {
  kpis: IProductionManagerKpis;
  bays: IProductionManagerBay[];
  assemblies: string[];
}

export interface IProductionManagerOverviewResponse
  extends DefaultResponseWithData<IProductionManagerOverview> {}

export type ProductionManagerView = "Line" | "Bays";
